<template>
  <div>
    <h1 class="title">VUOI SAPERE IL VERDETTO?</h1>

    <div class="subtitle">
      <strong>Lascia qui tuoi dati</strong> e scopri il risultato!
      <span v-if="showCouponDiscount">
        Per te una sorpresa speciale:
        <strong
          >{{ wizardData.couponDiscount }}% di sconto sul vostro primo ordine!</strong
        ></span
      >
      <span v-if="showCouponDefault">
        Per te una sorpresa speciale:
        <strong
          >{{ wizardData.couponDiscountDefault }}% di sconto sul vostro primo
          ordine!</strong
        >
      </span>
    </div>

    <form class="form max-w-xs mx-auto" @submit.prevent>
      <div class="form-group">
        <label class="form-label" for="delivery_name">Nome</label>
        <input
          v-model="$v.form.name.$model"
          type="text"
          placeholder=""
          class="form-control"
          id="delivery_name"
        />
        <div v-if="!$v.form.name.alpha" class="error">
          utilizzare solo lettere per il nome
        </div>
        <div v-else-if="$v.form.name.$error" class="error">campo obbligatorio</div>
      </div>

      <div class="form-group">
        <label class="form-label" for="email">La tua email</label>
        <input
          v-model="$v.form.email.$model"
          type="text"
          placeholder=""
          class="form-control"
          id="email"
        />
        <div v-if="$v.form.email.$error && !$v.form.email.required" class="error">
          campo obbligatorio
        </div>
        <div v-if="$v.form.email.$error && !$v.form.email.email" class="error">
          il valore inserito non è un indirizzo email valido
        </div>
      </div>

      <div class="form-group">
        <label class="form-label" for="phone_number">Numero di Telefono</label>
        <input
          v-model="$v.form.phoneNumber.$model"
          type="text"
          placeholder=""
          class="form-control"
          id="phone_number"
        />
        <div
          v-if="!$v.form.phoneNumber.required && $v.form.phoneNumber.$error"
          class="error"
        >
          campo obbligatorio
        </div>
        <div v-else-if="!$v.form.phoneNumber.itPhoneNumber" class="error">
          inserire un numero telefonico corretto, es: "02123456" oppure "3401234567"
        </div>
        <div v-else-if="!$v.form.phoneNumber.numeric" class="error">
          si prega di indicare un numero valido senza spazio
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { required, numeric, email, or } from "vuelidate/lib/validators";
import { customValidators } from "../constants.js";

export default {
  props: {
    wizardData: {
      type: Object,
      required: true,
    },
    dogData: {
      type: Object,
      required: true,
    },
    listData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      form: {
        name: this.wizardData.name,
        email: null,
        phoneNumber: null,
      },
    };
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
      name: {
        required,
        alpha: customValidators.alpha,
      },
      phoneNumber: {
        required,
        numeric,
        itPhoneNumber: or(
          customValidators.italianPhoneNumber,
          customValidators.italianMobileNumber
        ),
      },
    },
  },
  computed: {
    showCouponDiscount() {
      return this.wizardData.couponDiscount != null;
    },
    showCouponDefault() {
      return (
        this.wizardData.couponDiscount == null && this.wizardData.couponCodeDefault != ""
      );
    },
  },
  watch: {},
  methods: {
    submit() {
      this.$v.$touch();
      return new Promise((resolve, reject) => {
        if (!this.$v.$invalid) {
          resolve({
            form: {
              name: this.form.name,
              email: this.form.email.toLowerCase(),
              phoneNumber: this.form.phoneNumber,
            },
          });
        } else {
          reject("invalid entry");
        }
      });
    },
  },
  mounted() {},
  activated() {
    this.form.name = this.wizardData.name;
    this.form.email = this.wizardData.email;
    this.form.phoneNumber = this.wizardData.phoneNumber;
    this.$v.$reset();
  },
};
</script>
